import * as React from "react";
import { DatePicker } from "@fluentui/react/lib/DatePicker";
import {
  CommandBarButton,
  IDatePickerStyles,
  Label,
  Stack,
  TooltipHost,
} from "@fluentui/react";
import { dateIndexes } from "../../../../../config/constants";
import { firstDayOfWeek, DayPickerStrings } from "../../../../../config/dateSettings";
import { IBaseInputProps } from "../../../../../interfaces/advancedSearch/IBaseInputProps";
import { LanguageContext } from "../../../../../../../utilities/LocalizationModule";
import { DateService } from "../../../../../services/dateService";

export const DatePickerFieldInput: React.FunctionComponent<IBaseInputProps> = props => {
  const languageStrings = React.useContext(LanguageContext);
  const [fromto, setFromTo] = React.useState([null, null]);
  const onSelectFromDate = (date: Date | null | undefined): void => {
    const value = [date, fromto[1]];
    setFromTo(value);
    props.handleValueChange(props.searchInputData?.index, value);
  };

  const onSelectToDate = (date: Date | null | undefined): void => {
    // const value = [fromto[0] ?? new Date(), date];
    const value = [fromto[0], date];
    setFromTo(value);
    props.handleValueChange(props.searchInputData?.index, value);
  };

  const getValue = (dateIndex: number) => {
    if (props.searchInputData?.value == "[today]" || !props.searchInputData?.value) {
      return null;
    }

    return props.searchInputData?.value[dateIndex];
  };

  const datePickerStyles: Partial<IDatePickerStyles> = { root: { width: "100%" } };

  return (
    <>
      <Stack horizontal verticalAlign="end" horizontalAlign="stretch" style={{ width: "100%" }} tokens={{ childrenGap: 5 }}>
        <Stack style={{ width: "100%" }}>
          <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
            <Label>
              {props.displayName}
            </Label>
            <TooltipHost content={languageStrings.Clear} >
              <CommandBarButton
                iconProps={{ iconName: "clear", style: { fontSize: 12, paddingTop: 3, paddingBottom: 3 } }}
                styles={{
                  root: {
                    fontSize: 12,
                    minWidth: 0,
                  }
                }}
                onClick={() => onSelectFromDate(undefined)}
              />
            </TooltipHost>
          </Stack>
          <DatePicker
            styles={datePickerStyles}
            firstDayOfWeek={firstDayOfWeek}
            strings={DayPickerStrings}
            allowTextInput
            parseDateFromString={DateService.parseDateFromString}
            value={getValue(dateIndexes.from)}
            placeholder={languageStrings.From}
            ariaLabel={languageStrings.From}
            showMonthPickerAsOverlay={true}
            onSelectDate={onSelectFromDate}
            className="xb-sp-input"
          />
        </Stack>
        <Stack style={{ width: "100%" }}>
          <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
            <Label>
              {props.displayName}
            </Label>
            <TooltipHost content={languageStrings.Clear} >
              <CommandBarButton
                iconProps={{ iconName: "clear", style: { fontSize: 12, paddingTop: 3, paddingBottom: 3 } }}
                styles={{
                  root: {
                    fontSize: 12,
                    minWidth: 0
                  }
                }}
                onClick={() => onSelectToDate(undefined)}
              />
            </TooltipHost>
          </Stack>
          <DatePicker
            firstDayOfWeek={firstDayOfWeek}
            styles={datePickerStyles}
            allowTextInput
            parseDateFromString={DateService.parseDateFromString}
            value={getValue(dateIndexes.to)}
            strings={DayPickerStrings}
            placeholder={languageStrings.To}
            ariaLabel={languageStrings.To}
            showMonthPickerAsOverlay={true}
            className="xb-sp-input"
            onSelectDate={onSelectToDate}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default DatePickerFieldInput;
